<template>
  <div class="main-wrap">
    <div class="container">
      <div class="top" v-if="isPC">
        <div></div>
<!--        <img class="logo" @click="toJump" src="../assets/images/home_logo.png" alt="">-->

        <div class="top_btn">
          <div class="btn1" @click="toBack">
            <img src="../assets/images/home.png" alt="">
            <span>返回主页</span>
          </div>
          <div class="btn2" @click="toBack1">
            <img src="../assets/images/search.png" alt="">
            <span>继续查询</span>
          </div>
        </div>
      </div>
      <div class="top1" v-if="!isPC">
        <div class="top_btn">
          <div class="btn1" @click="toBack">
            <img src="../assets/images/home.png" alt="">
            <span>返回主页</span>
          </div>
          <div class="btn2" @click="toBack1">
            <img src="../assets/images/search.png" alt="">
            <span>继续查询</span>
          </div>
        </div>
<!--        <img src="../assets/images/home_logo.png" alt="">-->
      </div>
      <div class="info-wrap zs-main zhengshu1" v-if="isPC">
        <div class="table_wrap">
<!--          <div class="table_title"> <span>成员单位</span> <img src="../assets/images/title1.png" alt=""> <span>结果公示</span></div>-->
          <div class="title-wrap">
            <span>企业证书查询结果公示</span>
            <span>ENTERPRISE CERTIFICATE INQUIRY</span>
          </div>
        </div>
        <table border="0" class="table_1" v-if="info">
          <tr>
<!--            <th colspan="4">单位基本信息</th>-->
            <th colspan="4"><img src="../assets/images/dian.png" alt="">  <div>单位基本信息</div> <img src="../assets/images/dian.png" alt=""> </th>
          </tr>
          <tr>
            <td>单位名称</td>
            <td colspan="3">{{ info.name }}</td>
          </tr>
          <tr>
            <td>信用代码</td>
            <td colspan="3">{{ info.code }}</td>
          </tr>
          <tr>
            <td>法定代表人</td>
            <td>{{ info.daibiao }}</td>
            <td>所属行业</td>
            <td>{{ info.hangye }}</td>
          </tr>
          <tr>
            <td>单位地址</td>
            <td colspan="3">{{ info.address }}</td>
          </tr>
          <tr>
            <td style="border-bottom-left-radius: 12px">经营范围</td>
            <td style="border-bottom-right-radius: 12px;padding-right: 80px;padding-top: 15px;padding-bottom: 15px" colspan="3">{{ info.fanwei }}</td>
          </tr>
          <tr>
<!--            <th colspan="4">委员会意见</th>-->
            <th colspan="4"><img src="../assets/images/dian.png" alt="">  <div>委员会意见</div> <img src="../assets/images/dian.png" alt=""> </th>
          </tr>
          <tr>
            <td colspan="4" style="padding: 15px;">{{ info.yijian }}</td>
          </tr>
          <tr>
            <td style="border-bottom-left-radius: 12px">成员单位有效期</td>
            <td style="border-bottom-right-radius: 12px" colspan="3">{{ formattedDate(info.expire_time) }}</td>
          </tr>
        </table>
      </div>
      <div class="info-wrap zs-main zhengshu1" v-if="!isPC">
        <div class="table_wrap">
<!--          <div class="table_title"> <span>成员单位</span> <img src="../assets/images/title1.png" alt=""> <span>结果公示</span></div>-->
          <div class="title-wrap">
            <span>成员单位查询结果公示</span>
            <span>THE QUERY RESULT IS PUBLICIZED</span>
          </div>
        </div>
        <table border="0" class="table_1" v-if="info">
          <tr>
            <th colspan="4"><img src="../assets/images/dian.png" alt="">  <div>单位基本信息</div> <img src="../assets/images/dian.png" alt=""> </th>
          </tr>
          <tr>
            <td>单位名称</td>
            <td colspan="3">{{ info.name }}</td>
          </tr>
          <tr>
            <td>信用代码</td>
            <td colspan="3">{{ info.code }}</td>
          </tr>
          <tr>
            <td>法定代表人</td>
            <td>{{ info.daibiao }}</td>
          </tr>
          <tr>
            <td>所属行业</td>
            <td>{{ info.hangye }}</td>
          </tr>
          <tr>
            <td>单位地址</td>
            <td colspan="3">{{ info.address }}</td>
          </tr>
          <tr>
            <td>经营范围</td>
            <td colspan="3" style="padding-right: 15px;padding-top: 10px;padding-bottom: 10px">{{ info.fanwei }}</td>
          </tr>
          <tr style="margin-top: 10px">
<!--            <th colspan="4">委员会意见</th>-->
            <th colspan="4"><img src="../assets/images/dian.png" alt="">  <div>委员会意见</div> <img src="../assets/images/dian.png" alt=""> </th>
          </tr>
          <tr>
            <td colspan="4" style="padding: 15px;">{{ info.yijian }}</td>
          </tr>
          <tr>
            <td>成员单位有效期</td>
            <td colspan="3">{{ formattedDate(info.expire_time) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import {
  type_list,
  companyCertificate,
  userCertificate,
  configinfo
} from "@/api/index";
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      info:null,
      isPC:true
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }

    let info = JSON.parse(sessionStorage.getItem('companyInfo'))
    // this.info = info
    let ajax = {
      name:info.name,
      code:info.code,
    }
    this.getDetail(ajax)
  },
  methods: {
    toJump(){
      window.open('https://zxx.org.cn/')
    },
    getDetail(ajax){
      companyCertificate(ajax).then(res => {
        if (res.code == 1) {
          this.info = res.data
        }
      })
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    formattedDate(data) {
      if (typeof data === 'string' && /^\d{4}年\d{1,2}月\d{1,2}日$/.test(data)) {
        return data;
      }
      const date = new Date(data);

      // 检查是否是有效日期
      if (isNaN(date.getTime())) {
        console.warn('无效的日期格式:', data);
        return data || ''; // 或返回原始值/空字符串
      }

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}年${month}月${day}日`;
    },
    toBack(){
      sessionStorage.removeItem('companyInfo')
      this.$router.push({
        path: '/',
        query: { }
      })
    },
    toBack1(){
      sessionStorage.removeItem('companyInfo')
      this.$router.push({
        path: '/',
        query: { index:3 }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.main-wrap{
  background: url('../assets/images/bg.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: white;
  font-family: Arial, sans-serif;
  min-height: 100vh;
  width: 100%;

}

.container {
  padding: 30px 50px 30px 50px;
  margin: 0 auto;
}

.top1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  width: calc(100%);
  img{
    width: 100%;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo{
    cursor: pointer;
  }
}

.top_btn {
  display: flex;
  align-items: center;
}

.top_btn .btn1 {
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.top_btn .btn1 img{
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.top_btn .btn2 {
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_btn .btn2 img{
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.info-wrap {
  width: 1296px;
  text-align: center;
  border-radius: 30px;
  margin: 50px auto 0;
}

.zs-main.zhengshu1 table{
  border-collapse: collapse;
  width: 100%;
}
.zs-main.zhengshu1 th{
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  width: 1024px;
  height: 64px;
  background: linear-gradient( 270deg, rgba(16, 150, 183, .7) 0%, rgba(6, 84, 157, .7) 100%);
  border-radius: 12px 12px 0px 0px;
  img{
    width: 12px;
    height: 12px;
  }
  div{
    display: inline-block;
    margin: 0 30px;
  }
}
.table_wrap{
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
.table_title{
  display: flex;
  align-items: center;
}
.table_title span{
  text-align: center;
  font-size: 38px;
  color: #000;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;

}
.table_title img{
  margin:0 5px;
}
.zs-main.zhengshu1 td{
  width: 25%;
}
.zs-main.zhengshu1 table td{
  border: 1px solid #373793;
}
.zs-main.zhengshu1 .table_1 td:first-child,.zs-main.zhengshu1 .table_1 td:nth-child(3n){
  height: 60px;
  font-size: 20px;
  color: #ffffff;
  font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
  font-weight: bold;
  background-color: rgba(16, 16, 53, 1);
}
.zs-main.zhengshu1 .table_1 td:nth-child(2n),.zs-main.zhengshu1 .table_1 td:nth-child(4n){
  height: 60px;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 20px;
  background-color: rgba(16, 16, 53, 1);
}
.table_2{
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}
.table_3{
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}

.title-wrap{
  position: relative;
  width: 100%;
}
.title-wrap span:nth-child(1){
  font-family: PingFang SC;
  font-weight: 800;
  font-size: 42px;
  color: #FEFEFE;
}

.title-wrap span:nth-child(2){
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 30px;
  color: #FFFFFF;
  opacity: 0.1;
  position: absolute;
  top: 18px;
  left: calc((100% - 530px)/2);
  text-align: center;
}


@media only screen and (max-width: 600px) {
  .container {
    width: 100%;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
  }

  .info-wrap {
    text-align: center;
    margin: 30px 10px 0 10px;
    border-radius: 15px;
    padding: 30px 20px;
    box-sizing: border-box;
    width: 100%;
  }
  .table_wrap{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .table_title{
    display: flex;
    align-items: center;
  }
  .table_title span{
    text-align: center;
    font-size: 30px;
    color: #fff;
    font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
    font-weight: bold;
    margin-left: 5px;
  }
  .table_title img{
    width: 62px;
  }
  .zs-main.zhengshu1 th{
    height: 50px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }


  .top_btn {
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -10px;
  }

  .top_btn .btn1 {
    margin-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .top_btn .btn1 img{
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .top_btn .btn2 {
    margin-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .top_btn .btn2 img{
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .title-wrap{
    position: relative;
    width: 100%;
  }
  .title-wrap span:nth-child(1){
    font-family: PingFang SC;
    font-weight: 800;
    font-size: 20px;
    color: #FEFEFE;
  }

  .title-wrap span:nth-child(2){
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    opacity: 0.1;
    position: absolute;
    top: 10px;
    left: calc((100% - 280px)/2);
    text-align: center;
  }
  .zs-main.zhengshu1 .table_1 td:first-child,.zs-main.zhengshu1 .table_1 td:nth-child(3n){
    height: 50px;
    font-size: 16px;
    color: #ffffff;
    font-family: "宋体", SimSun, "微软雅黑", "Microsoft YaHei", sans-serif;
    font-weight: bold;
    background-color: rgba(16, 16, 53, 1);
  }
  .zs-main.zhengshu1 .table_1 td:nth-child(2n),.zs-main.zhengshu1 .table_1 td:nth-child(4n){
    height: 50px;
    font-size: 14px;
    color: #ffffff;
    text-align: left;
    padding-left: 20px;
    background-color: rgba(16, 16, 53, 1);
  }
}

</style>
